module.exports = __webpack_public_path__ + "img/Data.d02f0871.png";